import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { pb } from "@/lib/pocketbase";
import { useSession } from "@/providers/session-provider";
import type { Collections } from "@/types/pocketbase.ts";

export const useFile = () => {
	const session = useSession();
	const token = useQuery({
		queryKey: ["files-token"],
		queryFn: async () => {
			const token = await pb.files.getToken();

			return token;
		},
		staleTime: 120_000,
		enabled: !!session,
	});

	const getUrl = useCallback(
		({
			collectionName,
			id,
			filename,
			thumb,
		}: {
			collectionName: keyof typeof Collections;
			id?: string;
			filename?: string;
			thumb?: string;
		}) => {
			if (token.isLoading || !token.data || !filename || !id) {
				return;
			}

			const thumbUrl = pb.files.getURL(
				{
					collectionName,
					id,
				},
				filename,
				{
					thumb,
					token: token.data,
				}
			);

			return thumbUrl;
		},
		[token.data, token.isLoading]
	);

	return { getUrl };
};
